import Extractor from './extractor.js';

class Song extends Extractor{

  extract(item){
    const result = super.extract(item);
    const data = item.pagemap;

    result['song'] = this.getData(
      [
        {instance: data, object:'musicrecording', property: 'name'},        
      ], null);

    result['singer'] = this.getData(
      [
        {instance: data, object:'musicgroup', property: 'name'},        
      ], null);

    result['album'] = this.getData(
      [
        {instance: data, object:'musicalbum', property: 'name'},        
      ], null);

    return result;
  }
}

export default (Song);


// WEBPACK FOOTER //
// ./src/search/extractor/song.js